import { render } from "./IconTrekPassengers.vue?vue&type=template&id=5ea05aee"
import script from "./IconTrekPassengers.vue?vue&type=script&lang=js"
export * from "./IconTrekPassengers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__